<template>
  <div class="relative flex items-start">
    <div class="flex items-center h-5">
      <input
        type="checkbox"
        :id="id"
        :name="name"
        :required="required"
        :disabled="disabled"
        :value="inputValue"
        v-model="model"
        class="focus:ring-green-500 h-4 w-4 text-green-600 border-gray-300"
      />
    </div>
    <div class="ml-3 text-sm">
      <label :for="id" class="font-medium text-gray-700"
        ><slot></slot>{{ required ? " *" : "" }}</label
      >
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  name: String,
  id: String,
  modelValue: [String, Number, Boolean],
  inputValue: [String, Number, Boolean],
  tabindex: Number,
  required: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  error: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["update:modelValue"]);

const isTruthy = (val) => val === true || val === 1 || val === "1" || val === "true";

const toOriginalFormat = (boolValue) => {
  const original = props.modelValue;
  if (typeof original === "string") {
    if (original === "true" || original === "false") {
      return boolValue ? "true" : "false";
    }
    return boolValue ? "1" : "0";
  }
  if (typeof original === "number") {
    return boolValue ? 1 : 0;
  }
  return boolValue;
};

const model = computed({
  get() {
    return isTruthy(props.modelValue);
  },
  set(value) {
    emit("update:modelValue", toOriginalFormat(value));
  },
});
</script>
